import { createLoaderImp } from '../../../../components/ozmoit/common';
import { getFormDataAction } from '../actions';

const {
  useLoaderData: useSearchFiltersLoaderData,
  LoaderConsumerSimple,
  LoaderProvider,
} = createLoaderImp({
  action: getFormDataAction,
});

function SearchFiltersLoader({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  return (
    <LoaderProvider {...props}>
      <LoaderConsumerSimple>{children}</LoaderConsumerSimple>
    </LoaderProvider>
  );
}

export { SearchFiltersLoader, useSearchFiltersLoaderData };
